export * from "./BlockquoteFigure.js";
